import { ENDPOINT_WORKSPACE_SETTINGS } from '../config'
import type { UpdateWorkspaceRequest, UpdateWorkspaceResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const updateWorkspace = async (
  workspaceSlug: string,
  request: UpdateWorkspaceRequest,
): Promise<UpdateWorkspaceResponse> => {
  const response = await AuthAxios.patch<UpdateWorkspaceResponse>(
    `${ENDPOINT_WORKSPACE_SETTINGS}/${workspaceSlug}/settings/general`,
    request,
  )
  return response.data
}

export default updateWorkspace
